import React, { useEffect, useRef, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import TabsController from "../../../../components/TabsController";
import EpicButton from "../BoardHeader/epicButton/EpicButton";
import { useEpic } from "../../../../reactQuery/epics";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import CreateEpic from "../BoardHeader/epicButton/CreateEpic";
import RightArrow from "../../../../styles/svg/right-arrow.svg";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { TooltipName } from "../../../../utils/Enums";
import { isAdmin } from "../../../../utils/constants";
import { useResponsive } from "../../../../hooks/useResponsive";
import useBoardIdByKey from "../../../../hooks/useBoardIdByKey";

const MilestoneTabs = React.memo(({ boardName, isOwner }) => {
  const { id } = useBoardIdByKey();
  const [milestone, setMilestone] = useCustomSearchParams("milestone");
  const [noMilestone, setNoMilestone] = useCustomSearchParams("noMilestone");
  const tabContainerRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);
  const isMobile = useResponsive("down", "md");

  const { epics } = useEpic(id);
  const names = epics?.data?.data?.responseData || [];
  const unCompletedMileStones = names?.filter(
    (item) => item.completed == false
  );

  const today = moment();
  const sortedMilestone = unCompletedMileStones
    .filter(
      (item) =>
        item.start_date && !moment(item.start_date).isAfter(today, "day")
    )
    .sort((a, b) => {
      if (a.target_release_date && b.target_release_date) {
        return (
          new Date(a.target_release_date) - new Date(b.target_release_date)
        );
      } else if (a.target_release_date) {
        return -1; // Objects with `target_release_date` come first
      } else if (b.target_release_date) {
        return 1;
      } else {
        return new Date(a.start_date) - new Date(b.start_date);
      }
    });

  const selectMilestone = (event, newValue) => {
    // setMilestone("milestone", newValue);
  };
  const scrollRight = useCallback(() => {
    const scrollElement = document.querySelector(".MuiTabs-flexContainer");
    if (scrollElement) {
      scrollElement.scrollTo({
        left: scrollElement.scrollLeft + 500, // Adjust as needed
        behavior: "smooth", // Enables smooth scrolling
      });
    }
  }, []);

  useEffect(() => {
    const checkScrollable = () => {
      if (tabContainerRef.current) {
        const parentElement = tabContainerRef.current.parentNode;
        const thirdDiv = parentElement?.querySelector(".MuiTabs-flexContainer");
        if (thirdDiv) {
          setIsScrollable(thirdDiv.scrollWidth > thirdDiv.clientWidth + 160);
        }
      }
    };

    checkScrollable();
    window.addEventListener("resize", checkScrollable);

    return () => {
      window.removeEventListener("resize", checkScrollable);
    };
  }, [names]);

  return (
    <div className={`milestone-tabs-container ${isMobile ? "mobile-milestone-tabs-container" : ""}`}>
      <TabsController
        value={milestone ? milestone * 1 : ""}
        onChange={selectMilestone}
        tabsOptions={sortedMilestone}
        tabsRef={tabContainerRef}
        leftChild={
          <div
            className={`milestone-drop-down ${
              milestone || noMilestone === "true" ? "before_milestone" : ""
            }`}
          >
            <EpicButton
              boardNameDetails={boardName}
              isTab={true}
              selectedMilestone={milestone ? milestone * 1 : ""}
            />
          </div>
        }
      >
        <>
          <div className="milestone-tab-right-space"></div>
          {(isScrollable && !isMobile) && (
            <div
              className={`fade-right ${
                isOwner || isAdmin() || boardName?.data?.responseData?.board_permission?.is_admin ? "margin-right-for-admin" : "right-zero"
              }`}
            >
              <Tooltip title={TooltipName.BOARD_PAGE.MORE_MILESTONES}>
                <img
                  src={RightArrow}
                  onClick={scrollRight}
                  className="cursor-pointer"
                  style={{ pointerEvents: "all" }}
                  alt="more-milestone-btn"
                />
              </Tooltip>
            </div>
          )}
          {(isOwner || isAdmin() || boardName?.data?.responseData?.board_permission?.is_admin) && (
            <div className="milestone-create-epic-btn">
              <CreateEpic isTab={true} />
            </div>
          )}
        </>
      </TabsController>
    </div>
  );
});

export default MilestoneTabs;
